import React, { useState } from 'react';
import SubscriptionSideBar from './SubscriptionSidebar';
import FooterTrustChat from '../../components/common/FooterTrustChat';
import Navbar from '../../components/common/Navbar';
import SubscriptionSection1 from './SubscriptionSection1';
import SubscriptionSection2 from './SubscriptionSection2';

function Subscription() {
  const [showFirst, setShowFirst] = useState(true);
  const [showSecond, setShowSecond] = useState(false);
  return (
    <div className="Subscription-Policy-Main-Container">
      <div className="SubscriptionPolicy-Header-Container">
        <Navbar />
      </div>
      <div className="SubscriptionPolicy-Container">
        <div className="SubscriptionPolicy-SideContainer">
          <SubscriptionSideBar
            setShowFirst={setShowFirst}
            setShowSecond={setShowSecond}
          />
        </div>
        {showFirst && <SubscriptionSection1 />}
        {showSecond && <SubscriptionSection2 />}
      </div>
      <div className="SubscriptionPolicy-Footer">
        <FooterTrustChat />
      </div>
    </div>
  );
}

export default Subscription;
